import { render, staticRenderFns } from "./AMeasureProcessStepPreviewSimpleMessage.reg.vue?vue&type=template&id=61c13c36&"
import script from "./AMeasureProcessStepPreviewSimpleMessage.reg.vue?vue&type=script&lang=ts&"
export * from "./AMeasureProcessStepPreviewSimpleMessage.reg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports